import { useTranslation } from "react-i18next";
import { FloorDifference } from "utils/getFloorDifference";

export function useFloorDifferenceString(
  floorDifference: FloorDifference,
): string {
  const { t } = useTranslation();

  return floorDifference.amount === 0
    ? t("floor_change.no_change")
    : `${floorDifference.amount} ${t("floor_change.difference", { count: floorDifference.amount })} ${t(`floor_change.${floorDifference.direction}`)}`;
}
